import { render, staticRenderFns } from "./insstatistic1.vue?vue&type=template&id=1cffca6e&scoped=true&"
import script from "./insstatistic1.vue?vue&type=script&lang=js&"
export * from "./insstatistic1.vue?vue&type=script&lang=js&"
import style0 from "./insstatistic1.vue?vue&type=style&index=0&id=1cffca6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffca6e",
  null
  
)

export default component.exports